<script setup lang="ts">
    import { computed, toRef } from 'vue'

    import type { AlternativeFilterReadModel } from '@Alternatives/AlternativesViews/Domain/readmodels'
    import type { AttributeReadModel } from '@Alternatives/Attributes/Domain/readmodels'

    // ---------------- props / emits ----------------

    const props = defineProps<{
        propRm: AlternativeFilterReadModel
        propAttributes: AttributeReadModel[]
    }>()

    const emit = defineEmits<{
        (e: 'deleteFilter', rm: AlternativeFilterReadModel): void
    }>()

    // ---------------- shortcuts ----------------

    const rm = toRef(props, 'propRm')
    const attributes = toRef(props, 'propAttributes')

    // ---------------- derived ----------------

    const valueRequired = computed(() =>
        rm.value.Type !== 'PropertyIsKnown' &&
        rm.value.Type !== 'PropertyIsUnknown'
    )

    const opText = computed(() =>
    {
        switch (rm.value.Type)
        {
            case 'PropertyEq': return 'equals'
            case 'PropertyNotEq': return 'not equals'
            case 'PropertyLt': return 'less then'
            case 'PropertyLte': return 'less then or equal'
            case 'PropertyGt': return 'greater then'
            case 'PropertyGte': return 'greater then or equal'
            case 'PropertyIsKnown': return 'is known'
            case 'PropertyIsUnknown': return 'is unknown'
            case 'PropertyContains': return 'contains'
            default: return ''
        }
    })

    const headerText = computed(() =>
    {
        const attr = (attributes.value || []).find(a => a.Name === rm.value.Data.Name)

        if (!attr)
            return 'Choose attribute...'

        if (!rm.value.Data.Value && valueRequired.value)
            return 'Set condition...'

        return `${attr.Name} ${opText.value} ${valueRequired.value ? rm.value.Data.Value : ''}`
    })

    // ---------------- methods ----------------

    function deleteFilter()
    {
        emit('deleteFilter', rm.value)
    }
</script>


<template>
    <div class="card" style="display: inline-block;">
        <div @click="rm.IsEdited = true" class="card-header pointer">
            {{headerText}}
        </div>
        <div v-if="rm.IsEdited" class="card-body">
            <div class="form-group">
                <label>Attribute:</label>
                <select v-model="rm.Data.Name" class="form-control">
                    <option :value="null">Choose...</option>
                    <option v-for="attr in attributes" :value="attr.Name">{{attr.Name}}</option>
                </select>
            </div>
            <div class="form-group">
                <label>{{OpText}}:</label>
                <input v-if="valueRequired" type="text" v-model="rm.Data.Value" class="form-control">
            </div>
            <div class="d-flex justify-content-between">
                <div class="dropdown d-inline">
                    <button type="button" class="btn btn-outline-danger" data-toggle="dropdown">
                        Delete
                    </button>
                    <div class="dropdown-menu">
                        <div class="btn-group">
                            <button type="button" class="btn btn-outline-secondary">Cancel</button>
                            <button @click="deleteFilter" type="button" class="btn btn-danger">Confirm</button>
                        </div>
                    </div>
                </div>

                <button @click="rm.IsEdited = false" class="btn btn-primary">Update</button>
            </div>
        </div>
    </div>
</template> 